import React from 'react';
import styles from './index.css';
import HotListItem from './hotListItem';
const raf = require('raf');
class HotList extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hotList: [],
            initLeft: window.innerWidth - 38,
            left: window.innerWidth - 38,
            current: 0,
        };
        this.handleTouchStart = (e) => {
            const { hotList } = this.state;
            if (hotList.length === 1)
                return;
            const touch = e.touches[0];
            this.startX = touch.pageX;
            this.startY = touch.pageY;
            this.moveX = 0;
            this.moveY = 0;
        };
        this.handleTouchMove = (e) => {
            e.preventDefault();
            const { hotList, initLeft } = this.state;
            if (hotList.length === 1)
                return;
            const touch = e.touches[0];
            this.moveX = touch.pageX - this.startX;
            this.moveY = touch.pageY - this.startY;
            this.setState({
                left: initLeft - this.moveX,
            });
        };
        this.handleTouchCancel = () => {
            if (!this.moveX || this.moveX === 0)
                return;
            const { hotList, initLeft } = this.state;
            if (Math.abs(this.moveY) > Math.abs(this.moveX)) {
                this.setState({
                    left: initLeft,
                });
                return;
            }
            if (hotList.length === 1)
                return;
            raf(this.step);
        };
        this.handleTouchEnd = () => {
            if (!this.moveX || this.moveX === 0)
                return;
            const { hotList, initLeft } = this.state;
            if (Math.abs(this.moveY) > Math.abs(this.moveX)) {
                this.setState({
                    left: initLeft,
                });
                return;
            }
            if (hotList.length === 1)
                return;
            raf(this.step);
        };
        this.step = () => {
            let { left, current } = this.state;
            const { hotList, initLeft } = this.state;
            if (left < initLeft) {
                left -= 10;
            }
            else if (left > initLeft) {
                left += 10;
            }
            this.setState({
                left,
            });
            if ((this.moveX > 0 && left < initLeft - (window.innerWidth - 26)) || (this.moveX === 0 && left < initLeft)) {
                raf.cancel(this.step);
                if (initLeft - (window.innerWidth - 26) === -12) {
                    this.setState({
                        left: (window.innerWidth - 26) * (hotList.length - 2) - 12,
                        initLeft: (window.innerWidth - 26) * (hotList.length - 2) - 12,
                        current: hotList.length - 3,
                    });
                }
                else {
                    this.setState({
                        left: initLeft - (window.innerWidth - 26),
                        initLeft: initLeft - (window.innerWidth - 26),
                        current: --current,
                    });
                }
            }
            else if ((this.moveX < 0 && left > initLeft + (window.innerWidth - 26)) ||
                (this.moveX === 0 && left > initLeft)) {
                raf.cancel(this.step);
                if (initLeft + (window.innerWidth - 26) === (window.innerWidth - 26) * (hotList.length - 1) - 12) {
                    this.setState({
                        left: window.innerWidth - 38,
                        initLeft: window.innerWidth - 38,
                        current: 0,
                    });
                }
                else {
                    this.setState({
                        left: initLeft + (window.innerWidth - 26),
                        initLeft: initLeft + (window.innerWidth - 26),
                        current: ++current,
                    });
                }
            }
            else {
                raf(this.step);
            }
        };
        this.setLocation = (translateX) => {
            return 'WebKitCSSMatrix' in window ? `translate3d(-${translateX}px, 0, 0)` : `translate(-${translateX}px, 0)`;
        };
        this.handleClick = () => {
            const { handleCallNewsApp } = this.props;
            handleCallNewsApp();
        };
        this.commentBox = React.createRef();
    }
    componentDidMount() {
        if (this.commentBox.current)
            this.commentBox.current.addEventListener('touchmove', this.handleTouchMove.bind(this), false);
        const hotList = this.props.content;
        if (hotList.length > 1) {
            hotList.splice(0, 0, hotList[hotList.length - 1]);
            hotList.push(hotList[1]);
        }
        this.setState({
            hotList,
        });
    }
    componentWillUnmount() {
        if (this.commentBox.current)
            this.commentBox.current.removeEventListener('touchmove', this.handleTouchMove.bind(this));
    }
    render() {
        const { hotList, left, current } = this.state;
        const { handleCallNewsApp } = this.props;
        const dotList = [];
        for (let i = 0; i < hotList.length - 2; i++) {
            dotList.push(React.createElement("li", { key: i, className: i === current ? styles.current : '' }));
        }
        const swiperWidth = (window.innerWidth - 26) * hotList.length;
        const props = {
            style: hotList.length > 1
                ? {
                    width: swiperWidth,
                    transform: this.setLocation(left),
                }
                : {},
        };
        return (React.createElement("div", { className: styles.hotListBox },
            React.createElement("div", { className: styles.hotList },
                React.createElement("div", Object.assign({ className: styles.swiper_box }, props, { ref: this.commentBox, onTouchStart: this.handleTouchStart, onTouchCancel: this.handleTouchEnd, onTouchEnd: this.handleTouchEnd }), hotList.map((item, index) => (React.createElement("div", { key: index, className: styles.swiper, onClick: this.handleClick },
                    React.createElement("div", null,
                        React.createElement(HotListItem, { content: item }))))))),
            React.createElement("div", { className: styles.dots },
                React.createElement("ul", { className: styles.dotList }, dotList))));
    }
}
export default HotList;
